import { EditableTableCell } from 'components/EditableTableCell';
import type { ActKc2StatusEnum } from 'gql/graphql';
import { DeviationEnum } from 'gql/graphql';

import type React from 'react';
import { memo } from 'react';

import { useMethodsErrorHandlingModal } from './useMethodsErrorHandlingModal';

import Styles from './WorkOrderPriceKC2VolumeEdit.module.css';

interface IWorkOrderPriceKC2VolumeEditProps {
    actKC2Id: number;
    workOrderPriceId: number;
    defaultValue: string;
    actKC2Status: ActKc2StatusEnum;
    onChange: (reloadRowsIds?: number[] | null) => void;
    deviation: DeviationEnum;
    disabled?: boolean;
    style?: React.CSSProperties;
}

export const WorkOrderPriceKC2VolumeEdit = memo((props: IWorkOrderPriceKC2VolumeEditProps) => {
    const { actKC2Id, workOrderPriceId, defaultValue, actKC2Status, disabled, onChange, deviation, style } = props;

    const { handleOnChange, getRequestData, getRequestError, getRequestStatus } = useMethodsErrorHandlingModal(
        actKC2Id,
        workOrderPriceId,
        defaultValue,
        actKC2Status,
    );

    return (
        <div className={Styles.WorkOrderPriceKC2VolumeEdit}>
            <EditableTableCell
                decimalScale={3}
                disabled={disabled}
                fieldValue={defaultValue}
                reloadHandler={onChange}
                updateRequest={handleOnChange}
                updateStatus={getRequestStatus}
                requestResultObj={getRequestData}
                requestErrors={getRequestError}
                errorModalTitle="Редактирование Объёма"
                leftSide={deviation === DeviationEnum.Up ? '▲' : undefined}
                inputStyles={style}
            />
        </div>
    );
});

WorkOrderPriceKC2VolumeEdit.displayName = 'WorkOrderPriceKC2VolumeEdit';
